import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import {
	Placeholder,
	ButtonGroup,
	__experimentalToggleGroupControl as ToggleGroupControl,
	__experimentalToggleGroupControlOption as ToggleGroupControlOption,
	Button,
	Dashicon,
	Modal,
	TabPanel,
	TabList,
	Tab,
	PanelRow,
	PanelColumn,
	RangeControl,
	BaseControl,
} from '@wordpress/components';
import InspectorResponsiveLabel2, {
	valueToMediaValue,
	mediaValueToValue,
} from '../inspector-responsive-label-2';
import InspectorDashCustomIcon from '../inspector-dash-custom-icon';
import { toCamelCase } from '../../functions';

function toTitleCase( str ) {
	if ( ! str ) return '';
	return str.charAt( 0 ).toUpperCase() + str.slice( 1 ).toLowerCase();
}

const InspectorSelectButtonResponsive = ( props ) => {
	const {
		label,
		options,
		value,
		onChange,
		iconButton,
		isResetButton = false,
		isMedia = true,
		isUnit = false,
	} = props;

	const deviceType = useSelect( ( select ) => {
		const store = select( 'core/edit-post' );
		const editorStore = select( 'core/editor' );
		let device = '';
		if (
			store &&
			typeof store.__experimentalGetPreviewDeviceType === 'function'
		) {
			device = store.__experimentalGetPreviewDeviceType();
		} else if (
			editorStore &&
			typeof editorStore.getDeviceType === 'function'
		) {
			device = editorStore.getDeviceType();
		}
		return device;
	}, [] );

	const currentMedia = toTitleCase( deviceType ) || 'Desktop';

	const getLabel = ( iconButton, item ) => {
		return iconButton ? (
			<InspectorDashCustomIcon icon={ item.iconName ?? item?.icon } />
		) : (
			item.label
		);
	};

	return (
		<BaseControl id="alpha-accordion-type" __nextHasNoMarginBottom>
			<InspectorResponsiveLabel2
				label={ label ?? 'Default Label' }
				isResetButton={ isResetButton }
				isMedia={ isMedia }
				isUnit={ isUnit }
			/>

			<ToggleGroupControl
				id="alpha-accordion-type"
				className="flex w-full gap-0 p-0"
				value={ mediaValueToValue( value, currentMedia ) }
				style={ { padding: '0px' } }
				onChange={ ( val ) =>
					onChange( valueToMediaValue( val, currentMedia, value ) )
				}
				isBlock
				__nextHasNoMarginBottom={ true }
				__next40pxDefaultSize={ true }
			>
				{ options?.map( ( item, key ) => (
					<ToggleGroupControlOption
						className="flex-1 text-center justify-center"
						key={ key }
						value={ item?.value }
						label={ getLabel( iconButton, item ) }
					></ToggleGroupControlOption>
				) ) }
			</ToggleGroupControl>
		</BaseControl>
	);
};

export default InspectorSelectButtonResponsive;
